import { captureException } from '@sentry/nextjs'

import appConfig from '~/config/app'
import authService from '~/services/auth.service'
import { callApi } from '~/services/axiosInstance.service'
import growthbookAnalytics from '~/analytics/growthbook/growthbookAnalytics'

export interface GrowthbookEvent {
  userId?: number
  userPsuedoId?: string
  experimentId: string
  variationId: number
}

const storeGrowthbookEvent = async (event: GrowthbookEvent): Promise<void> => {
  try {
    await callApi({
      method: 'POST',
      url: '/v1/activity/growthbook/events',
      data: event,
    })
  } catch (error) {
    captureException(error, { tags: { feature: 'growthbook', action: 'event-store' } })
  }
}

export const growthbookTrackingCallback = async (experimentId: string, variationId: number): Promise<void> => {
  // Flags still evaluate in the school platform, but experiment exposure is not recorded — this would
  // otherwise ship a `_ga`-derived pseudo id alongside the real user id.
  if (appConfig.isSchoolPlatform) return

  let userPsuedoId: undefined | string

  if (typeof window !== 'undefined') {
    if (!appConfig.isProdEnvironment) {
      // eslint-disable-next-line no-console
      console.log('Viewed Experiment ===>', {
        experimentId,
        variationId,
      })
    }

    userPsuedoId = document?.cookie
      .match(/_ga=(.+?);/)?.[1]
      .split('.')
      .slice(-2)
      .join('.')
  }

  growthbookAnalytics.viewedExperiment(experimentId, variationId)

  const userId = authService.getUserId()

  const event = {
    userId,
    userPsuedoId,
    experimentId,
    variationId,
  }

  await storeGrowthbookEvent(event)
}
